module.exports = __webpack_public_path__ + "static/media/mad.3b4b8682.png";